// eslint-disable-next-line no-restricted-imports
import { Switch, SwitchProps } from 'antd'

export type { SwitchProps }

export default (props: SwitchProps) => {
    return <Switch size="small" {...props} />
}
